<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="8">
                <rkm-form-input
                    :validations="validations.nome"
                    disabled
                    label="Nome"
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :validations="validations.grau"
                    label="Grau de prioridade"
                    number
                    v-model="model.grau"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                grau: {
                    required: true,
                    min_value: 0,
                    max_value: 6,
                },
            }
        },
    },
    created() {
        this.repositories = {
            prioridade: this.getConectaSusRepository('painelSenha.prioridade')
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.prioridade.edit(this.id)
                .then(response => {
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    const request = {
                        grau: this.model.grau
                    }

                    this.repositories.prioridade.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('save', response)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
    },
}
</script>